import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { postalCodesMap } from './postalCodes';
import postalCodes from './postalCodes.txt';
async function getFileContents() {
  const file = await fetch(postalCodes);
  const fileContents = await file.text();
  return fileContents;
}
async function createPostalCodeMap() {
  const fileContents = await getFileContents();
  const rows = fileContents.split('\n');
  const newPostalCodesMap = new Map();
  rows.forEach(row => {
    const rowsItems = row.split('\t');
    newPostalCodesMap.set(rowsItems[0], rowsItems[1]);
  });
  return newPostalCodesMap;
}
export default function PostalCodesLoader() {
  const setMap = useSetRecoilState(postalCodesMap);
  useEffect(() => {
    createPostalCodeMap().then(newPostalCodesMap => {
      setMap(newPostalCodesMap);
    });
  }, [setMap]);
  return null;
}